<template>
	<div class="sign">
        <div class="sign-search">
			<div class="btn-box">
				<van-field
					size="small"
					v-model="key"
					placeholder="预约单号/进仓单号"
					:formatter="relationNumberFmt"
					@keyup.13="getList()"
				/>
			</div>

			<div class="toSearch-box">
				<button class="sign-toSearch" @click="getList()">
					查询
				</button>
			</div>
		</div>

		<template v-if="startSearch">
        	<van-loading size="24px" vertical>加载中...</van-loading>
		</template>
		<template v-else>
            <template v-if="Object.keys(info).length">
                <div class="sign-item">	
                    <ul>
                        <li>
                            <div class="sign-list">
                                <strong>单号信息</strong>
                            </div>
                            <div class="sign-list">
                                <p>单号：{{ info.trackNumber }}</p>
                                <p>箱数：{{ info.boxCount }}</p>
                            </div>
                            <div class="sign-list">
                                <p>总重量：{{ info.totalWeight }}</p>
                                <p>总体积：{{ info.totalVolume }}</p>
                            </div>
                            <div class="sign-list" v-if="info.bussbusinessType != 2">
                                <strong>产品信息</strong>
                            </div>
                            <div class="sign-list" v-if="info.bussbusinessType != 2">
                                <p>SKU：{{ info.sku }}</p>
                            </div>
                            <div class="sign-list">
                                <p v-if="info.bussbusinessType != 2">数量：{{ info.totalQty }}</p> 
                                <p style="white-space: nowrap;">
                                    <span>{{info.bussbusinessType == 2 ? '送货箱数：':'送货数量：'}}</span>
                                    <input type="number" :readonly="true" v-model="deliveryQty" @change="inputNumChange('deliveryQty')" maxlength="16" class="btn-num">
                                </p>
                            </div>
                            <div class="sign-list">
                                <strong>送货地址</strong>
                            </div>
                            <div class="sign-list">
                                <p>{{ info.address }}<br>{{info.contacter}} {{info.phone}}</p>
                            </div>
                        </li>
                    </ul>
                </div>

                <van-tabs
                    v-model="tabActive"
                    line-width="50%"
                    line-height="2px"
                    color="#1989fa"
                    @click="tabClick"
                >
                    <van-tab title="车辆派送">
                        <div>
                            <van-form validate-first @submit="submit" label-width="100px" label-align="right" :readonly="info.bookingStatus === 4">
                                <!-- 通过 validator 进行函数校验 -->
                                <van-field
                                    v-model="submitData1.expectedTime"
                                    name="expectedTime"
                                    label="送货日期："
                                    :readonly="true"
                                    placeholder="请选择送货日期"
                                    @click="carTimeClick"
                                    :rules="[{ required: true }]"
                                />
                                <span class="tipSpan">
                                    <van-field
                                        readonly
                                        clickable
                                        name="picker"
                                        :value="selectValue"
                                        :rules="[{ required: true }]"
                                        label="送货时间："
                                        placeholder="请选择送货时间"
                                        @click="showSelectPicker = true"
                                    >
                                        <template #button v-if="selectValue == '19:00 至 21:00'">
                                            <span>该时段为加班时间，会收取加班费用</span>
                                        </template>
                                    </van-field>
                                </span>
                                <van-field
                                    v-if="submitData1.suggestTime"
                                    v-model="submitData1.suggestTime"
                                    center
                                    clearable
                                    name="suggestTime"
                                    :readonly="true"
                                    label="建议送货时间："
                                    >
                                    <template #button>
                                        <van-button size="small" type="info" native-type="button" @click="changeTime">确定</van-button>
                                    </template>
                                </van-field>
                                <van-field
                                    v-model="submitData1.driverName"
                                    name="driverName"
                                    label="司机："
                                    placeholder="请输入司机"
                                    maxlength="50"
					                :formatter="relationNumberFmt"
                                    :rules="[{ required: true}]"
                                />
                                <van-field
                                    v-model="submitData1.driverPhone"
                                    name="driverPhone"
                                    label="司机电话："
                                    placeholder="请输入司机电话"
                                    maxlength="20"
                                    type="number"
					                :formatter="phoneFmt"
                                    :rules="[{ required: true,validator:driverPhoneValid, message: '请输入正确电话' }]"
                                />
                                <van-field
                                    v-model="submitData1.driverCarNumber"
                                    name="driverCarNumber"
                                    label="车牌："
                                    placeholder="请输入车牌"
                                    maxlength="20"
					                :formatter="carNumberFmt"
                                    :rules="[{ required: true,validator:carValid, message: '请输入正确车牌' }]"
                                />
                                <van-field
                                    v-model="submitData1.bookingUser"
                                    name="bookingUser"
                                    label="预约人："
                                    placeholder="请输入预约人"
                                    maxlength="50"
					                :formatter="relationNumberFmt"
                                    :rules="[{ required: true }]"
                                />
                                <van-field
                                    v-model="submitData1.bookingPhone"
                                    name="bookingPhone"
                                    label="预约电话："
                                    placeholder="请输入预约电话"
                                    type="number"
                                    maxlength="20"
                                    :readonly="true"
                                    :rules="[{ required: true,validator:driverPhoneValid, message: '请输入正确的电话' }]"
                                />
                                <van-field
                                    v-if="submitData1.statusshow"
                                    center
                                    clearable
                                    :readonly="true"
                                    label="预约状态："
                                    class="status"
                                    >
                                    <template #button>
                                        <van-button size="mini" plain :color="statusColArr[info.bookingStatus]" native-type="button" >{{submitData1.statusshow}}</van-button>
                                    </template>
                                </van-field>
                                <div style="margin: 16px;text-align:center;" v-if="info.bookingStatus !== 4">
                                    <van-button type="info" style="margin-right:5%;width:47.5%;" native-type="button" @click="cancelBooking"> 取消预约 </van-button>
                                    <van-button type="info" style="width:47.5%;" native-type="submit"> 调整保存 </van-button>
                                </div>
                            </van-form>
                        </div>
                    </van-tab>
                    <van-tab title="快递派送">
                        <div class="sign-photo-cpntent">
                            <div class="sign-photo-box">                        
                                <van-form validate-first @submit="submit" label-width="100px" label-align="right" :readonly="info.bookingStatus === 4">
                                    <!-- 通过 validator 进行函数校验 -->
                                    <van-field
                                        v-model="submitData2.expectedTime"
                                        name="expectedTime"
                                        label="送货日期："
                                        :readonly="true"
                                        placeholder="请选择送货日期"
                                        @click="deliveryTimeClick"
                                        :rules="[{ required: true }]"
                                    />
                                    <span class="tipSpan">
                                        <van-field
                                            readonly
                                            clickable
                                            name="picker"
                                            :value="selectValue"
                                            :rules="[{ required: true }]"
                                            label="送货时间："
                                            placeholder="请选择送货时间"
                                            @click="showSelectPicker = true"
                                        >
                                            <template #button v-if="selectValue == '19:00 至 21:00'">
                                                <span>该时段为加班时间，会收取加班费用</span>
                                            </template>
                                        </van-field>
                                    </span>
                                    <van-field
                                        v-if="submitData2.suggestTime"
                                        v-model="submitData2.suggestTime"
                                        center
                                        clearable
                                        name="suggestTime"
                                        :readonly="true"
                                        label="建议送货时间："
                                        >
                                        <template #button>
                                            <van-button size="small" type="info" native-type="button" @click="changeTime">确定</van-button>
                                        </template>
                                    </van-field>
                                    <van-field
                                        v-model="submitData2.logisticsCompany"
                                        name="validator"
                                        label="快递公司："
                                        placeholder="请输入快递公司"
                                        maxlength="100"
					                    :formatter="relationNumberFmt"
                                        :rules="[{ required: true }]"
                                    />
                                    <van-field
                                        v-model="submitData2.logisticsNumber"
                                        name="validator"
                                        label="物流单号："
                                        placeholder="请输入物流单号"
                                        maxlength="50"
					                    :formatter="relationNumberFmt"
                                        :rules="[{ required: true }]"
                                    />
                                    <van-field
                                        v-model="submitData2.bookingUser"
                                        name="validator"
                                        label="预约人："
                                        placeholder="请输入预约人"
                                        maxlength="50"
					                    :formatter="relationNumberFmt"
                                        :rules="[{ required: true }]"
                                    />
                                    <van-field
                                        v-model="submitData2.bookingPhone"
                                        name="validator"
                                        label="预约电话："
                                        type="number"
                                        :readonly="true"
                                        placeholder="请输入预约电话"
                                        maxlength="20"
					                    :formatter="phoneFmt"
                                        :rules="[{ required: true,validator:driverPhoneValid, message: '请输入正确的电话' }]"
                                    />
                                    <van-field
                                        v-if="submitData2.statusshow"
                                        center
                                        clearable
                                        :readonly="true"
                                        label="预约状态："
                                        class="status"
                                        >
                                        <template #button>
                                            <van-button size="mini" plain :color="statusColArr[Number(info.bookingStatus)-1]" native-type="button" >{{submitData2.statusshow}}</van-button>
                                        </template>
                                    </van-field>
                                    <div style="margin: 16px;" v-if="info.bookingStatus !== 4">
                                        <van-button type="info" style="margin-right:5%;width:47.5%;" native-type="button" @click="cancelBooking"> 取消预约 </van-button>
                                        <van-button type="info" style="width:47.5%;" native-type="submit"> 调整保存 </van-button>
                                    </div>
                                </van-form>
                            </div>
                        </div>
                    </van-tab>
                </van-tabs>
            </template>

            <template v-else>
                <van-empty image="search" description="暂无数据" />
            </template>
		</template>

        <van-calendar v-model="show" ref="calendar" title="选择日期" @confirm="onConfirm" :show-confirm="false" :style="{ height: '500px' }" :show-subtitle="true" @month-show="monthShow"/>
        <van-popup v-model="showSelectPicker" position="bottom" class="van_pop_main">
            <van-picker
                confirm-button-text="确定" 
                cancel-button-text="取消"
                show-toolbar
                :columns="selectColumns"
                @confirm="onSelectConfirm"
                @cancel="showSelectPicker = false"
            />
        </van-popup>
		<van-popup v-model="showPicker" round position="bottom" :lazy-render="false">
            <van-picker show-toolbar title="请选择预约时间" :columns="columns"	confirm-button-text="确定" 
				cancel-button-text="取消"
                :item-height="40"
                :visible-item-count="6"
				@confirm="onPickerConfirm"
				@cancel="showPicker=false"
                @change="onPickerChange"
                ref="pickerTime"/>
		</van-popup>
	</div>
</template>

<script>
import { Icon, Badge, Picker, Popup, Field, Empty, List, PullRefresh, cell, Toast, DropdownMenu, DropdownItem, Loading, Form, Tabs, Tab, Button, DatetimePicker, Calendar } from 'vant';
import util from "util/date";
import { getUrlParams} from "util/util";
import {isMobile,isCarPlate} from "util/validate";
import { getMakeAppointmentQuery,sendCode,editBookingDelivery,editBookingStatus,editSuggestTime, GetBookingPro } from '@/api/mobile_Reserve/mobileReserve_api';

export default {
	data() {
		return {
            selectValue: '',
            selectColumns: [],
            showSelectPicker: false,
			list: [],
			key: '',
			loading: false,
			startSearch: false,
            tabActive: 0,
            info: {},
            submitData1: {
            },
            submitData2: {
            },
            show: false,
            isReadonlyTime: false,
            showPicker: false,
            isToDay: false,
            deliveryQty: 0,
            deliveryType: 1, // 1车辆派送2快递派送
            statusColArr: ['#c1c1c1','#1989fa','#07c160','#ee0a24']
		}
	},
	components: {
		[Icon.name]: Icon,
        [DropdownMenu.name]: DropdownMenu,
		[DropdownItem.name]: DropdownItem,
		[Badge.name]: Badge,
		[Picker.name]: Picker,
		[Popup.name]: Popup,
		[Empty.name]: Empty,
		[List.name]: List,
		[PullRefresh.name]: PullRefresh,
		[cell.name]: cell,
		[Toast.name]: Toast,
    	[Loading.name]: Loading,
    	[Form.name]: Form,
    	[Tabs.name]: Tabs,
    	[Tab.name]: Tab,
    	[Button.name]: Button,
		[Field.name]: Field,
    	[DatetimePicker.name]: DatetimePicker,
		[Field.name]: Field,
		[Calendar.name]: Calendar
	},
	computed: {
        columns: function (){

            let h1 = new Date().getHours(),
            m1 = new Date().getMinutes(),
            h2 = new Date().getHours(),
            m2 = new Date().getMinutes()

            
            let h1Arr,m1Arr,h2Arr,m2Arr
            if(this.isToDay){ // 如果日期是当天
                h1Arr = this.generateArr(h1,24,'h')
                m1Arr = this.generateArr(m1,60,'m')
                h2Arr = this.generateArr(h2,24,'h')
                m2Arr = this.generateArr(m2,60,'m')
            }else{  // 如果日期不是当天
                h1Arr = this.generateArr(0,24,'h')
                m1Arr = this.generateArr(0,60,'m')
                h2Arr = this.generateArr(0,24,'h')
                m2Arr = this.generateArr(0,60,'m')
            }

            let columns = [
                    {
                        values: h1Arr,
                        defaultIndex: 0
                    },
                    {
                        values: m1Arr,
                        defaultIndex: 0
                    },
                    {
                        values: ['-'],
                        defaultIndex: 0
                    },
                    {
                        values: h2Arr,
                        defaultIndex: 0
                    },
                    {
                        values: m2Arr,
                        defaultIndex: 0
                    },
                ]

            return columns
        }
	},
	created() {
		this.init()
	},
	methods: {
        getSelectColumns(date) {
            if(date){
                GetBookingPro({ estimatedDate: date }).then(res => {
                    if (res.status === 200 && res.success) {
                        let newColumns = res.response.map(item => {
                            let proportion = item.proportion * 100
                            let color = proportion == 100 ? '#f5a596' : proportion > 50 ? '#f100f1' : '#b1e47c'
                            let status = proportion == 100 ? '约满' : proportion > 50 ? '紧张' : '宽松'
                            return {
                                text: `
                                    <div style='display:flex'>
                                        <div style='margin-right: 30px;width: 110px;'>
                                            <div>${item.expectedTime.split('-')[0]} 至 ${item.expectedTime.split('-')[1]}</div>
                                            <div class="progressBarMain">
                                                <div class="progressBar" style="width:${proportion}%;background: ${color}"></div>
                                            </div>
                                        </div>
                                        <div style='color:${color}'>${status}</div>
                                    </div>
                                `,
                                value: `${item.expectedTime.split('-')[0]} 至 ${item.expectedTime.split('-')[1]}`
                            }
                        })
                        this.$set(this, 'selectColumns', newColumns)
                    } else {
                        this.$set(this, 'selectColumns', [])
                    }
                })
            } else {
                this.$set(this, 'selectColumns', [])
            }
        },
        onSelectConfirm(value){
            this.selectValue = value.value;
            this.showSelectPicker = false;
        },
		init() {
            let params = getUrlParams(window.location.href)
			if(params && params.key){
				this.key = params.key
				this.getList()
			}
		},

        getList(){
            this.submitData1 = {}
            this.submitData2 = {}
            this.info = {}
            if(!this.key) return Toast('请输入查询单号')
            this.startSearch = true

            getMakeAppointmentQuery({key:this.key}).then(res=>{
                this.startSearch = false
                if(res.status === 200 && res.success){
                    
                    const {response} = res
                    this.info = response

                    const {expectedTime,estimatedDate,suggestTime,driverName,driverPhone,driverCarNumber,bookingUser,bookingPhone,logisticsCompany,logisticsNumber,statusshow,deliveryQty} = response

                    this.deliveryQty = deliveryQty

                    if(response.deliveryType === 1){
                        this.tabActive = 0
                        this.selectValue = expectedTime
                        this.$set(this.submitData1,'expectedTime',estimatedDate)
                        this.$set(this.submitData1,'driverName',driverName)
                        this.$set(this.submitData1,'driverPhone',driverPhone)
                        this.$set(this.submitData1,'driverCarNumber',driverCarNumber)
                        this.$set(this.submitData1,'suggestTime',suggestTime)
                        this.$set(this.submitData1,'statusshow',statusshow)
                    }else{
                        this.tabActive = 1
                        this.$set(this.submitData2,'expectedTime',estimatedDate)
                        this.selectValue = expectedTime
                        this.$set(this.submitData2,'suggestTime',suggestTime)
                        this.$set(this.submitData2,'logisticsCompany',logisticsCompany)
                        this.$set(this.submitData2,'logisticsNumber',logisticsNumber)
                        this.$set(this.submitData2,'statusshow',statusshow)
                    }
                    this.getSelectColumns(estimatedDate)
                    this.deliveryType = response.deliveryType
                    this.$set(this.submitData1,'bookingUser',bookingUser)
                    this.$set(this.submitData1,'bookingPhone',bookingPhone)
                    this.$set(this.submitData2,'bookingUser',bookingUser)
                    this.$set(this.submitData2,'bookingPhone',bookingPhone)
                }else{
                    Toast.fail(res.msg);
                }
            })
        },

        carTimeClick(){
            if(this.info.bookingStatus === 4) return
            this.show = true
        },

        deliveryTimeClick(){
            if(this.info.bookingStatus === 4) return
            this.show = true
        },
        
        isObjectValueEqual(a, b) {
            var aProps = Object.getOwnPropertyNames(a);

            for (var i = 0; i < aProps.length; i++) {
                var propName = aProps[i];
                var propA = a[propName];
                var propB = b[propName];
                if ( propA !== propB && propName != 'expectedTime' && propName != '__ob__') {
                    return false;
                }
            }
            return true;
        },

        // 检测
        checkAllChange(){
            const {deliveryQty,expectedTime} = this.info
            if(deliveryQty === this.deliveryQty &&  expectedTime === (this.deliveryType === 1 ? this.submitData1.expectedTime : this.submitData2.expectedTime) && (this.deliveryType === 1 ? this.isObjectValueEqual(this.submitData1,this.info):this.isObjectValueEqual(this.submitData2,this.info))){
                return true
            }else{
                return false
            }
        },

        checkChange(){
            if(this.info.suggestTime === (this.deliveryType === 1 ? this.submitData1.expectedTime : this.submitData2.expectedTime) && (this.deliveryType === 1 ? this.isObjectValueEqual(this.submitData1,this.info):this.isObjectValueEqual(this.submitData2,this.info))){
                return 1
            }else{
                return 2
            }
        },

        submit(){
            if(!this.deliveryQty) return Toast('请输入送货数量')
            if(this.checkAllChange()) return Toast('没有要提交的改动')

            const {trackNumber,sku,bookingDeliveryID} = this.info
            let expectedTimeData = this.selectValue.replaceAll('至', '-')
            const obj = {
                deliveryType:this.deliveryType,
                trackNumber,bookingDeliveryID,
                skuCode:sku,
                deliveryQty:this.deliveryQty,
                expectedType:this.checkChange(),
                expectedTime:expectedTimeData.replaceAll(' ',''),
                estimatedDate:this.deliveryType === 1 ? this.submitData1.expectedTime : this.submitData2.expectedTime
            }

            const data =  Object.assign({},this.deliveryType === 1 ? this.submitData1 : this.submitData2,obj) 

			Toast.loading({
				message: '调整中...',
				forbidClick: true,
			});
            editBookingDelivery(data).then(res=>{
				Toast.clear();
                if(res.status === 200 && res.success){
                    this.getList()
                    Toast.success(res.msg);
                }else{
                    Toast.fail(res.msg);
                }
            })
        },

        changeTime(){
            const {bookingDeliveryID,suggestTime} = this.info

            const data = {
                bookingDeliveryID,suggestTime
            }

			Toast.loading({
				message: '调整中...',
				forbidClick: true,
			});

            editSuggestTime(data).then(res=>{
                
				Toast.clear();
                if(res.status === 200 && res.success){
                    this.getList()
                    Toast(res.msg);
                }else{
                    Toast.fail(res.msg);
                }
            })
        },

        cancelBooking(){
            if(this.deliveryType === 1 && !this.submitData1.bookingPhone){
                return
            }

            if(this.deliveryType === 2 && !this.submitData2.bookingPhone){
                return
            }

            const {bookingDeliveryID} = this.info

			Toast.loading({
				message: '取消中...',
				forbidClick: true,
			});

            editBookingStatus({bookingDeliveryID}).then(res=>{
                
				Toast.clear();
                if(res.status === 200 && res.success){
                    this.getList()
                    Toast.success(res.msg);
                }else{
                    Toast.fail(res.msg);
                }
            })
            
        },

        formatDate(date) {
            let m = date.getMonth() + 1
            let d = date.getDate()
            m = m>9?m:`0${m}`
            d = d>9?d:`0${d}`
            return `${date.getFullYear()}-${m}-${d}`;
        },

        onConfirm(date) {
            this.show = false;
            // this.showPicker = true;
            this.isToDay = new Date().toDateString() === new Date(this.formatDate(date).replace(/\-/g, '/')).toDateString()
            this.deliveryType === 1 ? this.$set(this.submitData1,'expectedTime',this.formatDate(date)) : this.$set(this.submitData2,'expectedTime',this.formatDate(date))
            this.getSelectColumns(this.formatDate(date))
            if(this.isToDay){
                this.$refs.pickerTime.setColumnValue(0,new Date().getHours())
                this.$refs.pickerTime.setColumnValue(1,new Date().getMinutes())
                this.$refs.pickerTime.setColumnValue(3,new Date().getHours())
                this.$refs.pickerTime.setColumnValue(4,new Date().getMinutes())
            }else{
                this.$refs.pickerTime.setColumnValue(0,'00')
                this.$refs.pickerTime.setColumnValue(1,'00')
                this.$refs.pickerTime.setColumnValue(3,'00')
                this.$refs.pickerTime.setColumnValue(4,'00')
            }
        },

        onPickerConfirm(date) {
            const str = `${date[0]}:${date[1]}-${date[3]}:${date[4]}`
            const fn = (n)=>{
                return Number(date[n])
            }
            if(fn(0) < fn(3) || (fn(0) === fn(3) && fn(1) < fn(4)) ){
                this.$set( this[`submitData${this.deliveryType}`],'expectedTime',`${this[`submitData${this.deliveryType}`].expectedTime} ${str}`)
                this.showPicker = false
            }else{
                Toast('开始时间不能大于或等于结束时间')
            }
        },

        onPickerChange(Picker,allVal,curIndex){
            console.log(`当前值：${allVal}, 当前索引：${curIndex}`);

            if(curIndex === 0){
                if(Picker.getColumnIndex(curIndex) !== 0){
                    Picker.setColumnValues(1,this.generateArr(0,60,'m'))
                    Picker.setColumnValue(1,'00')
                }else{
                    Picker.setColumnValue(1,'00')
                    this.isToDay && Picker.setColumnValues(1,this.generateArr(new Date().getMinutes(),60,'m'))
                }
            }
            if(curIndex === 3){
                if(Picker.getColumnIndex(curIndex) !== 0){
                    Picker.setColumnValues(4,this.generateArr(0,60,'m'))
                    Picker.setColumnValue(4,'00')
                }else{
                    Picker.setColumnValue(4,'00')
                    this.isToDay && Picker.setColumnValues(4,this.generateArr(new Date().getMinutes(),60,'m'))
                }
            }
        },

        monthShow(val){
            
            const d = new Date(val.date)

            // 处理vant-ui 日历副标题显示问题
            const c = document.getElementsByClassName('van-calendar__weekdays')[0]
            c.innerHTML = ''
            c.innerHTML = '<span class="van-calendar__weekday">日</span><span class="van-calendar__weekday">一</span><span class="van-calendar__weekday">二</span><span class="van-calendar__weekday">三</span><span class="van-calendar__weekday">四</span><span class="van-calendar__weekday">五</span><span class="van-calendar__weekday">六</span>'
            
            const t = document.getElementsByClassName('van-calendar__header-subtitle')[0]
            t.innerHTML = `${d.getFullYear()}年`
        },

		relationNumberFmt(v){
			return v.trim()
		},

		carNumberFmt(v){
			return v.trim().toUpperCase()
		},

        phoneFmt(v){
			return v.trim().replace(/\-/g, '')
		},

        validator(val) {
            return /1\d{10}/.test(val);
        },

        driverPhoneValid(val) {
            return isMobile(val);
        },

        carValid(val) {
            return isCarPlate(val);
        },

        generateArr(cur,total,type){
            let arr = []
            for (let i = cur; i < total; i++) {
                i = i > 9 ? i:`0${i}`
                // const n = type === 'h' ? '时':'分'
                // arr.push(`${i}${n}`);
                arr.push(i);
            }
            return arr
        },
        
        inputNumChange(field) {
            let str = String(this[field])
            if(str.length>9){
                str = 0
            }
            let num = Number(str)
            // const {totalQty} = this.info
            // if(num > totalQty){
            //     Toast('送货数量大于可收货数量')
            //     num = Number(totalQty)
            // }else 
            if(num < 0){
                Toast('请输入正整数')
                num = 0
            }
            this[field] = parseInt(num)
        },

        tabClick(n,t) {
            this.selectValue = ''
            if(n === 1){
                
                if(this.submitData2.expectedTime){
                    if(this.submitData2.expectedTime.includes(' ')){
                        let arrs = this.submitData2.expectedTime.split(' ')
                        this.$refs.calendar.reset(new Date(arrs[0]))
                    }else{
                        this.$refs.calendar.reset(new Date(this.submitData2.expectedTime))
                    }
                }else{
                    this.$refs.calendar.reset(new Date())
                }
                this.$nextTick(function(){
                    this.deliveryType = 2
                })
            }else{

                if(this.submitData1.expectedTime){
                    if(this.submitData1.expectedTime.includes(' ')){
                        const {expectedTime} = this.submitData1
                        let arrw = expectedTime.split(' ')

                        this.$refs.calendar.reset(new Date(arrw[0]))
                    }else{
                        this.$refs.calendar.reset(new Date(this.submitData1.expectedTime))
                    }
                }else{
                    this.$refs.calendar.reset(new Date())
                }
                this.$nextTick(function(){
                    this.deliveryType = 1
                })
            }
        },

	}
}
</script>

<style lang="less" scoped>
::v-deep .sign-search .van-cell {
	border: 1px solid #adadad;
	margin-bottom: 7px;
	padding: 5px 10px;
}
.sign {
	// background-color: #fbf9fe;
}
.sign-search {
	box-sizing: border-box;
	width: 100%;
    padding: 10px 10px 3px 10px;
	display: flex;
}
.sign-search .btn-box {
	flex: 0.6;
}
.sign-search .toSearch-box {
	flex: 0.4;
	margin-left: 3%;
	min-height: 25px;
}
.sign-toSearch {
	width: 100%;
	height: 84%;
	min-height: 25px;
	background: linear-gradient(to right, #1d62f0 0%, #19d4fd 100%);
	border-radius: 5px;
	border: 0;
	color: #fff;
	font-size: 18px;
}
.toSearch-box {
	vertical-align: top;
}
.sign-item {
	// border-top: 1px solid #ccc;
    padding: 5px;
}
.sign-item li {
	// border-bottom: 1px solid #ccc;
	// background-color: #fbf9fe;
	padding: 3px 10px;
	font-size: 12px;
    box-shadow: 0px 0px 5px 0px #cccccc;
}
.sign-list{
    display: flex;
	margin: 5px 0;
    p{
		flex: 1;
		word-break: break-all;
		margin: 0;
    }
}
.tipSpan{
    ::v-deep .van-field__button{
        position: absolute;
        bottom: -14px;
        font-size: 10px;
        color: red;
        padding-left: 0;
    }
}
.btn-num{
    width: 40%;
}
::v-deep .status input {
    display: none !important;
}
::v-deep .status .van-field__button {
    padding-left: 0;
}
.van_pop_main {
    ::v-deep .progressBarMain {
        height: 4px;
        background: #fff;
        border: 1px solid #f5a596;
        border-radius: 4px;
    }

    ::v-deep .progressBar {
        background: #b1e47c;
        height: 4px;
    }
}
</style>